import { breakpoints, fontFamilies } from "@brightagency/headstart-common";
import { transparentize } from "polished";
import { Link } from "react-router-dom";
import styled, { css, keyframes } from "styled-components";
import { buttonResetStyles, letterSpacing } from "../../../utils";
import { colors } from "../../../utils/colors";

export const listingCardShadow = css`
    box-shadow: 0 3px 15px ${transparentize(0.83, "black")};
`;

export const Outer = styled.div`
    position: relative;
    background-color: white;
    border-radius: 15px;
    overflow: hidden;
    ${listingCardShadow}
    height: 100%;
    display: flex;
    flex-direction: column;
    transition: 200ms ease transform;
    will-change: transform;
    min-height: 315px;

    ${breakpoints.medium} {
        :hover {
            transform: translateY(-5px);
        }
    }

    &.isCompact{
        min-height: auto;
    }
`;

const skeletonAnimation = keyframes`
    0% {
        background-position: -160px
    }
    66% {
        background-position: 560px
    } 
    100% {
        background-position: 560px
    } 
`;

export const ListingCardSkeleton = styled(Outer)`
    background-image: linear-gradient(
        90deg,
        hsl(0, 0%, 92%) 0px,
        hsl(0, 0%, 95%) 100px,
        hsl(0, 0%, 92%) 200px
    );
    background-size: 800px;
    animation: 1s ease ${skeletonAnimation} infinite;
    box-shadow: none;
`;

export const Content = styled.div`
    padding: 25px 16px 16px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
`;

export const Title = styled(Link)`
    ${buttonResetStyles};
    text-decoration: none;
    font-family: ${fontFamilies.heading} !important;
    font-weight: 800;
    font-size: 18px;
    color: ${colors.brandDark};
    ${letterSpacing(-30)};
    line-height: 1;
    padding-bottom: 1px;
    overflow: hidden;

    .isCompact & {
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;

export const Distance = styled.div`
    font-size: 13px;
    line-height: 1;
    font-weight: 800;
    color: ${colors.brandMid};
    margin-top: 6px;
`;

export const Blurb = styled.div`
    font-size: 13px;
    color: ${colors.brandDark};
    margin-top: 8px;
`;

export const Bottom = styled.div`
    margin-top: auto;
    padding-top: 16px;
    position: absolute;
    bottom: 1rem;
    left: 1rem;
`;

export const Actions = styled.div`
    display: flex;
    justify-content: space-between;
    padding-top: 16px;
    gap: 8px;
`;

export const Tags = styled.div`
    margin-top: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
`;

export const Tag = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;

    border-radius: 4px;
    line-height: 1;
    font-size: 11px;
    padding: 6px;
    background-color: ${colors.brandXXXLight};

    color: ${colors.brandDark};

    svg {
        font-size: 14px;
    }
`;

export const FeaturedTag = styled.div`
    font-size: 12px;
    display: inline-block;
    color: ${colors.brandMid};
    margin: 0 0 12px 0;

    > div {
        border: 1px solid ${transparentize(0.5, colors.brandMid)};
        background-color: ${transparentize(0.9, colors.brandMid)};
        border-radius: 4px;
        padding: 2px 4px;
        display: inline-block;
        > *:first-child {
            margin-right: 4px;
        }
    }
`;
